// UNASCA è nata il 25 febbraio 1967
export const ANNO_FONDAZIONE = 1967;

export const annoCorrente = (oggi: Date = new Date()): number => oggi.getFullYear();

export const anniDallaFondazione = (oggi: Date = new Date()): number => {
  const primaDellAnniversario = oggi.getMonth() < 1 || (oggi.getMonth() === 1 && oggi.getDate() < 25);
  return oggi.getFullYear() - ANNO_FONDAZIONE - (primaDellAnniversario ? 1 : 0);
};
